import { Modal } from "react-bootstrap";
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import dayjs from 'dayjs';
import './ShoppingCartDialog.css';
import { useTranslation } from 'react-i18next';
import SECTION_SHOPPING_CART from
  '../dynamic_section/dynamic_1/template_01';
import { TENANT_BUCKET } from '../common/constants'
import ImageWithPlaceholder from './ImageWithPlaceholder'


const ShoppingCartDialog = (props) => {
  // const [remainingTime, setRemainingTime] = useState(null);
  const { cart } = props
  const { t } = useTranslation();
  const [cartProduct, setCartProduct] = useState([]);

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })

  const changeQuantity=()=>{
    
  }
  
  useEffect(() => {
    // let getCartProduct = localStorage.getItem('cart_product');

    // getCartProduct = JSON.parse(getCartProduct)
    // if (getCartProduct.length > 0) {
    //   setCartProduct(getCartProduct)
    // }
    if (cart !== "") {
      setCartProduct(JSON.parse(cart).reverse())

    }
  }, [cart])

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      id="shoppingCartModal"
      fullscreen={isDesktopOrLaptop ? false : true}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="subTitle">
          {t('shopping_cart')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="shoppingCart_container">

          {/* < SECTION_SHOPPING_CART desktopToggle={true}
            mobileToggle={true} label={`shoppingCartContainer`} id={`Section_shoppingCartContainer`}
            imageSize={`1x1`} contentPosition={`right`}
            actionPosition={`right`} rowDesktop={1}
            rowMobile={1} numberOfRow={-1}
            dataType={`shopping_cart`} noPadding={false} filter={``}
            titleToggle={false} titleIconToggle={true}
            cardPosition={``} pagination={true}
            autoplay={true} navigation={true}
            dynamicQuery={``} filterTabToggle={false}
            folderImage={``} noLink={false} data={cartProduct}/>   */}
          {
            cartProduct?.length ? (
              cartProduct.map(function (item, index) {
                return (
                  <div class="card_container">
                    <div class="card_wrap">
                      <figure class="card_image_wrap">
                        <ImageWithPlaceholder src={`${isDesktopOrLaptop ? (item._desktop_image?.url) : (item._mobile_image?.url)}`} placeholder={`https://storage.googleapis.com/tenant-images.imbaweb.com/image-loading/1x1.png`} alt={item.title} />
                      </figure>
                      <div class="color_primary content_container">
                        <article class="card_content_wrap">
                          <div class="card_content_title">
                            {item.name}
                          </div>
                          <div class="card_content_desc_container"></div>
                        </article>
                        <div class="card_action_wrap">
                          <div class="quantity_action_part">
                            <div class="number-input-button left" onclick={() => changeQuantity(item, -1)}>-</div>
                            <input type="number" className="shoppingCartQuantity" value={item.cart_quantity} />
                            <div class="number-input-button right" onclick={() => changeQuantity(item, 1)}>+</div>
                          </div>
                          <div class="button_action_part">
                            <button className="color_button font_button button_action">Remove</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (<div className="d-flex align-items-center justify-content-center flex-column">
              <img src={`${TENANT_BUCKET}/icon/noRecord.png`} alt={''} className="no_record_img" />
              <span className="pt-1">{t('no_record')}</span>
            </div>)
          }

        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ShoppingCartDialog;
